import DeliveryOrderLinesForm from '../../../../components/Purchasing/DeliveryOrder/Lines/DeliveryOrderLinesForm'
import React from 'react'
import { Modal } from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function DeliveryOrderLinesModal(props) {
  const { remove, submit, update, visible, modalType, formRef, onCancel, removing, submitting, isUpdatable } = props
  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Delivery Order Lines'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          visible={isUpdatable}
          submit={submit}
          remove={remove}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'Lines'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <DeliveryOrderLinesForm ref={formRef} {...props} />
    </Modal>
  )
}

DeliveryOrderLinesModal.propTypes = {}
DeliveryOrderLinesModal.defaultProps = {}

export default DeliveryOrderLinesModal
